Function.prototype.bindArgs =
    function (...boundArgs) {
        const targetFunction = this;
        return function (...args) {
            return targetFunction.call(this, ...boundArgs, ...args);
        };
    };